const locale = {
	
};

export default locale;
